import {
  roles,
} from "@/Enums"

import type {
  AuthorizedActions,
} from "@/authorization";

const customerDataPolicies: AuthorizedActions = {
  read: [roles.Hauptbenutzer, roles.Benutzer, roles.BenutzerKunde, roles.BenutzerFinanz, roles.BenutzerAussen],
  edit: [roles.Hauptbenutzer, roles.Benutzer, roles.BenutzerKunde, roles.BenutzerAussen],
  download: undefined
}

export {
  customerDataPolicies
}
